
import axios from 'axios'
import baseUrl from '../pai'

//竞拍公告列表
export const getActivityBroadcasts=(para)=>{
  return axios.get(baseUrl+'/open/activity_broadcasts',{params:{page:para.page,perPage:10}},{
    headers:{
      'Content-Type': 'application/json',
    }
  })
}
export const get_qiniu_token=(para)=>{
    return axios.get(baseUrl + '/common/get_qiniu_token',para,{
        headers:{
            'Content-Type': 'application/json',
        }
    })
}
export const toQiniu=(para)=>{
    return axios.post('https://upload.qiniup.com/',para,{
        headers:{
            'Content-Type': 'multipart/form-data',
        }
    })
}
